<template>
    <div class="why-love-you">
        <DefSliderWrapper>
            <swiper
                :modules="modules"
                :slides-per-view="1"
                :pagination="{ clickable: true }"
            >
                <swiper-slide
                    v-for="item in result.items"
                >
                    <DefInsertTildaSlider
                        v-if="item.html"
                        :result="item.html"
                    />
                    <DefVideo
                        v-else-if="item.video"
                        :result="item.video"
                    />
                    <a
                        v-else-if="item.pictures"
                        :href="item.link"
                    >
                        <DefPicture :result="item.pictures" />
                    </a>
                    <a
                        v-else-if="item.animation"
                        :href="item.link"
                    >
                        <DefPicture :result="item.animation" />
                    </a>
                </swiper-slide>
            </swiper>
        </DefSliderWrapper>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { useStore } from 'vuex';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import DefPicture from "../def/DefPicture/DefPicture";
// import DefVideo from "../def/DefVideo/DefVideo";
import DefInsertTildaSlider from "../def/DefInsertTilda/DefInsertTildaSlider";

const { result } = defineProps(['result']);

const modules = [Pagination];

const {
    getters: {
        ['global/getDeviceName']: getDeviceName,
    }
} = useStore();

</script>

<script>
export default {
    name: 'WhyLoveYou',
}
</script>

<style lang="scss" scoped>
.why-love-you{
    :deep{
        .def-picture{
            img{
                width: 100%;
            }
        }
        .def-video{
            width: 100%;
        }
        .swiper-wrapper {
            align-items: center;
        }
    }
}
</style>